import { Pipe, PipeTransform } from '@angular/core';
import { ContextType } from '@bn/shared/entities/index';
import { WafRuleSeverityEnum } from '../enums';

@Pipe({
  name: 'wafSeverityRule',
  standalone: true,
})
export class WafSeverityRulePipe implements PipeTransform {
  public wafRuleSeverityEnum = WafRuleSeverityEnum;

  transform(value: string): { text?: string; contextType?: ContextType } | undefined {
    const wafRuleSeverity = Number(value) as WafRuleSeverityEnum;

    const contextTypeMap: { [key in WafRuleSeverityEnum]: ContextType } = {
      [WafRuleSeverityEnum.Notice]: 'info',
      [WafRuleSeverityEnum.Warning]: 'warning',
      [WafRuleSeverityEnum.Critical]: 'danger',
    };

    return {
      text: this.wafRuleSeverityEnum[wafRuleSeverity] ?? '',
      contextType: contextTypeMap[wafRuleSeverity],
    };
  }
}
